export default function Footer(){
    return (
        <footer className="w-full px-2 sm:px-0 bg-gradient-to-b from-orange-400 to-orange-600 py-10 flex items-center justify-center">
            <p className="text-white">© 2024. Vmar. Todos os direitos reservados</p>
        </footer>
    )
}